import { MissionSegmentStatus, RouteAreaTypeId } from "@dtm-frontend/shared/ui";
import { Cartesian3 } from "cesium";
import { CesiumPolygonHierarchy } from "./cesium.models";

export interface RouteEntity {
    id: RouteAreaTypeId;
    hierarchy?: CesiumPolygonHierarchy;
    positions: Cartesian3[];
    segmentStatus?: MissionSegmentStatus;
    isMain?: boolean;
    isSelected?: boolean;
    isCollision?: boolean;
    isEmergency?: boolean;
    degreesPositions?: number[][];
    data?: Record<string, unknown>;
}
